import { ASTERISK_API_BASE } from '../config/bridge';

const readStoredExtension = () => {
  try {
    const extensionData = JSON.parse(localStorage.getItem('extension') || '{}');
    return String(
      extensionData.sipUsername ||
      extensionData.extensionNumber ||
      extensionData.extension ||
      ''
    ).trim();
  } catch {
    return '';
  }
};

const readStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem('user') || '{}');
  } catch {
    return {};
  }
};

const readStoredAgentMode = () => {
  try {
    return String(localStorage.getItem('frontOfficeNew_agentMode') || '').trim();
  } catch {
    return '';
  }
};

const readStoredAgentAvailability = () => {
  try {
    return String(localStorage.getItem('frontOfficeNew_agentAvailability') || '').trim();
  } catch {
    return '';
  }
};

const normalizePresenceStatus = (status) => String(status || '').trim().toLowerCase();

const getStoredPresenceStatus = (fallbackStatus = 'notready') => {
  const mode = readStoredAgentMode().toLowerCase();
  const availability = readStoredAgentAvailability().toLowerCase();

  if (mode === 'outbound') return 'notready';
  if (availability === 'ready') return 'idle';
  if (availability === 'not ready') return 'notready';
  if (availability === 'lunch') return 'lunch';
  if (availability === 'training') return 'training';
  if (availability === 'meeting') return 'meeting';
  if (availability === 'prayer') return 'prayer';
  if (availability === 'rest room') return 'restroom';

  return normalizePresenceStatus(fallbackStatus) || 'registered';
};

const readStoredQueueName = () => {
  try {
    const extensionData = JSON.parse(localStorage.getItem('extension') || '{}');
    return String(
      extensionData.queueName ||
      extensionData.QueueName ||
      extensionData.queuename ||
      ''
    ).trim();
  } catch {
    return '';
  }
};

const getAuthHeaders = () => {
  const headers = { 'Content-Type': 'application/json' };
  try {
    const token = localStorage.getItem('token');
    if (token) headers.Authorization = `Bearer ${token}`;
  } catch {
    // ignore
  }
  return headers;
};

export const syncAgentPresence = async (status = '') => {
  const extension = readStoredExtension();
  if (!extension) {
    return false;
  }

  const user = readStoredUser();
  const cmsUserId = String(
    user.UserID ||
    user.userId ||
    user.ID ||
    user.id ||
    ''
  ).trim();
  const cmsUserName = String(
    user.FullName ||
    user.UserName ||
    user.LoginName ||
    user.username ||
    user.loginName ||
    extension
  ).trim();
  const direction = readStoredAgentMode();
  const queueName = readStoredQueueName();
  const requestedStatus = normalizePresenceStatus(status);
  const nextStatus = !requestedStatus || requestedStatus === 'registered'
    ? getStoredPresenceStatus('notready')
    : requestedStatus;

  try {
    const response = await fetch(`${ASTERISK_API_BASE}/users/${encodeURIComponent(extension)}/status`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify({
        status: nextStatus,
        cmsUserId,
        cmsUserName,
        direction,
        queueName
      })
    });

    return response.ok;
  } catch {
    return false;
  }
};

export const unregisterAgentPresence = async () => {
  const extension = readStoredExtension();
  if (!extension) {
    return false;
  }

  try {
    const response = await fetch(`${ASTERISK_API_BASE}/register/${encodeURIComponent(extension)}`, {
      method: 'DELETE',
      headers: getAuthHeaders(),
      keepalive: true
    });

    return response.ok;
  } catch {
    return false;
  }
};

export const sendAgentHeartbeat = async () => {
  const extension = readStoredExtension();
  if (!extension) {
    return false;
  }

  try {
    const response = await fetch(`${ASTERISK_API_BASE}/users/${encodeURIComponent(extension)}/heartbeat`, {
      method: 'POST',
      headers: getAuthHeaders()
    });
    if (response.status === 404) {
      return syncAgentPresence();
    }
    return response.ok;
  } catch {
    return false;
  }
};

export const getStoredExtensionForPresence = () => readStoredExtension();
export const getStoredStatusForPresence = () => getStoredPresenceStatus('notready');
